// 首页和全屏地图共用。修改后重新构建/发布即可生效。
// 地址统一维护在 src/api/config.js
import { WATER_SYSTEM_MVT_URL } from '../api/config'

export const WATER_SYSTEM_CONFIG = {
  url: WATER_SYSTEM_MVT_URL,
  layerName: 'water_system',
  // false：不限制水系范围；true：按下方 bounds 限制请求并裁剪显示。
  restrictBounds: false,
  // 单位：度；west/east 为经度，south/north 为纬度。
  // 同时控制瓦片请求范围和边缘瓦片的显示裁剪。
  bounds: {
    west: 101.14,
    east: 105.10,
    south: 29.56,
    north: 35.10
  },
  style: {
    color: 'blue',
    weight: 2,
    opacity: 1,
    fill: false
  }
}
